// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { tbGame } from "../engine/tbGame";
export var ObjectPool = function (initialSize, createCallback) {
    "use strict";
    // Properties used by the engine
    this.visible = true;
    this.active = true;
    this.pool = [];
    this.createCallback = createCallback;
    for (var i = 0; i < initialSize; i++) {
        this.pool.push(this.createCallback());
    }
    tbGame.addToken(this);
};
ObjectPool.prototype.handleBeginStep = function (timePassed) {
    "use strict";
    for (var i = 0; i < this.pool.length; i++) {
        var f = this.pool[i];
        if (f.active) {
            f.update(timePassed);
        }
    }
};
ObjectPool.prototype.get = function () {
    for (var i = 0; i < this.pool.length; i++) {
        var f = this.pool[i];
        if (!f.active) {
            return f;
        }
    }
    var newObject = this.createCallback();
    this.pool.push(newObject);
    return newObject;
};
ObjectPool.prototype.clean = function () {
    for (var i = 0; i < this.pool.length; i++) {
        var f = this.pool[i];
        if (f.active) {
            f.remove();
        }
    }
};
